// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.get-token-page{
    width: 1000px;
    background-color: white;
    padding: 10px 12px;
    border-radius: 10px;
    margin: 20px 0px;
    height: 75vh;
}


.get-token-page .gettoken-title{
    margin: 10px 0px 20px;
    font-size: 30px;
}

.get-token-page form{
    margin-top: 30px;
}

.get-token-page form .input-row {
    display: flex;
    flex-direction: column;
    margin: 10px 0px;
}

.get-token-page form .input-row .input-label{
    font-weight: 700;

}

.get-token-page form .input-row input {
    width: 300px;
    padding: 6px 8px;
    border: 1px solid #e1e1e1;
    border-radius: 5px;
    margin-top: 5px;
}

.get-token-page form .input-row input:focus{
    outline: none;
}
 
.get-token-page .display-token
{
    width:1100px;
    max-width: 100%;
    background-color: #EEE;
    min-height: 30px;
    border-radius: 6px;
    margin: 20px auto;
    /* overflow-x: scroll; */
    text-overflow: ellipsis;
    overflow-wrap: break-word;  /* Modern equivalent of word-wrap */
    word-break: break-word;     /* Number of lines to show */
    -webkit-box-orient: vertical; /* Define vertical box layout */
    padding: 4px;
    
}
::-webkit-scrollbar {
    width: 0px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: transparent;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }

.get-token-page .getTknbtn {
    background-color: var(--main-color);
    color: white;
    border-radius: 6px;
    font-weight: bold;
    padding: 8px 30px;
    border: none;
    width: 300px;
    max-width: 100%;
    cursor: pointer;
    transition: var(--main-transition);
    margin-top:10px;
}

.get-token-page .getTknbtn:hover{
    opacity: .8;
}`, "",{"version":3,"sources":["webpack://./src/Pages/GetToken/getToke.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,yBAAyB,GAAG,mCAAmC;IAC/D,sBAAsB,MAAM,4BAA4B;IACxD,4BAA4B,EAAE,+BAA+B;IAC7D,YAAY;;AAEhB;AACA;IACI,UAAU;EACZ;;EAEA,UAAU;EACV;IACE,uBAAuB;EACzB;;EAEA,WAAW;EACX;IACE,uBAAuB;EACzB;;EAEA,oBAAoB;EACpB;IACE,uBAAuB;EACzB;;AAEF;IACI,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".get-token-page{\n    width: 1000px;\n    background-color: white;\n    padding: 10px 12px;\n    border-radius: 10px;\n    margin: 20px 0px;\n    height: 75vh;\n}\n\n\n.get-token-page .gettoken-title{\n    margin: 10px 0px 20px;\n    font-size: 30px;\n}\n\n.get-token-page form{\n    margin-top: 30px;\n}\n\n.get-token-page form .input-row {\n    display: flex;\n    flex-direction: column;\n    margin: 10px 0px;\n}\n\n.get-token-page form .input-row .input-label{\n    font-weight: 700;\n\n}\n\n.get-token-page form .input-row input {\n    width: 300px;\n    padding: 6px 8px;\n    border: 1px solid #e1e1e1;\n    border-radius: 5px;\n    margin-top: 5px;\n}\n\n.get-token-page form .input-row input:focus{\n    outline: none;\n}\n \n.get-token-page .display-token\n{\n    width:1100px;\n    max-width: 100%;\n    background-color: #EEE;\n    min-height: 30px;\n    border-radius: 6px;\n    margin: 20px auto;\n    /* overflow-x: scroll; */\n    text-overflow: ellipsis;\n    overflow-wrap: break-word;  /* Modern equivalent of word-wrap */\n    word-break: break-word;     /* Number of lines to show */\n    -webkit-box-orient: vertical; /* Define vertical box layout */\n    padding: 4px;\n    \n}\n::-webkit-scrollbar {\n    width: 0px;\n  }\n  \n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  \n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: transparent;\n  }\n  \n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: transparent;\n  }\n\n.get-token-page .getTknbtn {\n    background-color: var(--main-color);\n    color: white;\n    border-radius: 6px;\n    font-weight: bold;\n    padding: 8px 30px;\n    border: none;\n    width: 300px;\n    max-width: 100%;\n    cursor: pointer;\n    transition: var(--main-transition);\n    margin-top:10px;\n}\n\n.get-token-page .getTknbtn:hover{\n    opacity: .8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
